// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchBox_root__GcEmm","paper":"SearchBox_paper__lh_WV","largeSearchBox":"SearchBox_largeSearchBox__rSg9T","largeSearchBoxInput":"SearchBox_largeSearchBoxInput__3Nc4u"};